// Locally unique ID (LUID)
// Generates an identifier that is guarunteed to be unique locally on the browser.

let i = 0;

export default function LUID() {
  return `LUID-${++i}`;
}
